import { useQuery } from '@apollo/client/react';
import { useMemo } from 'react';

import { Sim } from '@generated/gql/graphql';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { getMobileTariffs as getMobileTariffsQuery } from '@utils/queries/mobile';

const useGetMobileTariffs = (sims: Sim[], isSubmitting: boolean) => {
  const { basketId } = useBasketContext();

  const selection = useMemo(() => ({ sims: sims.map(({ id }) => id) }), [sims]);

  const { loading, error, data, previousData } = useQuery(
    getMobileTariffsQuery,
    {
      variables: { basketId, selection },
      skip: isSubmitting,
    }
  );

  const result = data ?? previousData;

  return {
    loading,
    error,
    mobileTariffs: result?.mobileTariffs?.tariffs || [],
    discounts: result?.mobileTariffs?.discounts || [],
  };
};

export { useGetMobileTariffs };
